import { useElement } from './core/element.js';
const name = 's-avatar';
const props = {
    src: ''
};
const style = `:host{display:inline-flex;vertical-align:middle;justify-content:center;align-items:center;aspect-ratio:1;-webkit-aspect-ratio:1;position:relative;font-size:1rem;font-weight:600;width:40px;border-radius:50%;color:var(--s-color-on-tertiary, #ffffff);background:var(--s-color-tertiary, #5C5B7E)}::slotted(:is(svg,s-icon)){color:currentColor;fill:currentColor;width:24px}::slotted([slot=badge]){position:absolute;right:0;bottom:0;outline:solid 2px var(--s-color-surface, #F8F9FB);color:var(--s-color-on-success, #ffffff);background:var(--s-color-success, #006d43)}img{width:100%;height:100%;border-radius:inherit;position:absolute;inset:0}`
const template = `<slot></slot><slot name="badge"></slot>`
class Avatar extends useElement({
    style, template, props,
    setup(shadowRoot) {
        const img = document.createElement('img');
        return {
            src: (value) => {
                img.src = value;
                img.onload = () => {
                    this.dispatchEvent(new Event('load'));
                    shadowRoot.insertBefore(img, shadowRoot.children[0]);
                };
                img.onerror = () => {
                    this.dispatchEvent(new ErrorEvent('error'));
                    img.isConnected && shadowRoot.removeChild(img);
                };
            }
        };
    }
}) {
}
Avatar.define(name);
export { Avatar };
